import React, { useState, useEffect, useRef } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import SearchBoxMobile from "./SearchBoxMobile.jsx";
import { useSelector } from "react-redux";
import { useLazyLogoutQuery } from "../../redux/api/authApi";
import { useNavigate } from "react-router-dom";

function MobileDropdown() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [logout] = useLazyLogoutQuery();

  const logoutHandler = async () => {
    await logout();
    navigate(0); // Refresh the page
  };

  const closeDropdown = () => {
    setOpen(false);
  };

  return (
    <>
      <Link
        className="custom-navbar-tablet-mobile-dropdown-toggle"
        onClick={() => setOpen(!open)}
        id="dropDownMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded={open}
      >
        <Image src="/img/dropdown.png" alt="Menu" />
      </Link>
      <section
        ref={dropdownRef}
        className={`p-4 bg-white shadow-md rounded-md absolute top-16 left-0 w-full transition duration-300 ${
          open ? "block" : "hidden"
        }`}
      >
        <Link
          className="custom-navbar-tablet-mobile-dropdown-toggle"
          onClick={closeDropdown}
        >
          <i className="fas fa-times"></i>
        </Link>

        {/* Search bar for mobile */}
        <SearchBoxMobile  closeDropdown={closeDropdown} />

        <div className="mt-4 space-y-2">
          {/* 移动端主导航：显式 label，避免由路径自动生成导致大小写不规范 */}
          {[
            { label: "Products", path: "/products" },
            { label: "ODM Services", path: "/odm_services" },
            { label: "PCB Quote", path: "/get_quote" },
            { label: "Request a Quote", path: "/request_quote" },
            { label: "Contact Us", path: "/contact_us" },
          ].map(({ label, path }) => (
            <Link
              key={path}
              className="block px-4 py-2 text-sm text-blue-600 hover:bg-blue-100"
              to={path}
              onClick={closeDropdown}
            >
              {label}
            </Link>
          ))}
        </div>

        <div className="mt-4">
          {user ? (
            <>
              <Link
                className="block px-4 py-2 text-sm text-blue-600 hover:bg-blue-100"
                to="/me/profile"
                onClick={closeDropdown}
              >
                My Profile
              </Link>
              <Link
                className="block px-4 py-2 text-sm text-blue-600 hover:bg-blue-100"
                to="/me/orders"
                onClick={closeDropdown}
              >
                My Orders
              </Link>
              <Link
                className="block px-4 py-2 text-sm text-blue-600 hover:bg-blue-100"
                to="/me/update_profile"
                onClick={closeDropdown}
              >
                Update Profile
              </Link>
              <button
                className="block w-full px-4 py-2 text-sm text-left text-blue-600 hover:bg-blue-100"
                onClick={logoutHandler}
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                className="block px-4 py-2 text-sm text-blue-600 hover:bg-blue-100"
                to="/login"
                onClick={closeDropdown}
              >
                Sign in
              </Link>
              <span>
                New account?{" "}
                <Link
                  className="block px-4 py-2 text-sm text-blue-600 hover:bg-blue-100"
                  to="/signup"
                  onClick={closeDropdown}
                >
                  Sign up
                </Link>
              </span>
            </>
          )}
        </div>
      </section>
    </>
  );
}

export default MobileDropdown;
